export const ROUTE_I18N_MAPPING: { [key: string]: string } = {
  // Dashboard
  '/dashboard/location': 'dashboard_location',
  '/profile': 'profile',

  // Schedule
  '/schedule': 'schedule',
  '/departments': 'departments',
  '/availabilities': 'availabilities',
  '/user/availability': 'availability',

  // Payroll
  '/payroll/setup/implementation': 'payroll',

  // Manager
  '/task_manager': 'task_manager',
  '/manager_log': 'manager_log',

  // HR center
  '/hr_center/hr_pro': 'hr_center_hr_pro',
  '/hr_center/safety': 'hr_center_safety',

  // Team
  '/documents': 'documents',
  '/team': 'team',
  '/time_offs': 'time_offs',
  '/new_hire_onboarding': 'new_hire_onboarding',
};
